import { Component, OnDestroy, OnInit } from '@angular/core';
import { Table } from '@docpath/webcomponents/table';
import { Subscription } from 'rxjs';

import { HomeService } from '../../services/home.service';
import { HomeHttpService } from '../../services/home-http.service';
import { HomeTableService } from './home-table.service';

@Component({
  selector: 'app-home-table',
  templateUrl: './home-table.component.html'
})

export class HomeTableComponent implements OnInit, OnDestroy {
  table: Table;
  showLoading = false;
  disableTableSelectable: boolean;
  homeRefreshChangedSubscription?: Subscription;

  constructor(
    private readonly homeTableService: HomeTableService,
    private readonly homeHttpService: HomeHttpService,
    private readonly homeService: HomeService
  ) {
    this.table = this.homeTableService.initTable();
    this.disableTableSelectable = true;
  }

  ngOnInit(): void {
    this.homeTableService.hourLoaded.subscribe(result => {
      this.table.header = this.homeTableService.initTableHeader();
      this.table.body = this.homeTableService.initTableBody(result);
    });

    this.homeHttpService.showLoadingTableChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });
    if (!this.homeRefreshChangedSubscription) {
      this.homeRefreshChangedSubscription = this.homeService.homeRefreshChanged.subscribe(() => {
        this.homeTableService.loadHour(false);
      });
    }

    this.homeTableService.loadHour(true);
  }

  ngOnDestroy(): void {
      if (this.homeRefreshChangedSubscription) {
          this.homeRefreshChangedSubscription.unsubscribe();
      }
  }

}